import ABCyaLib from '@abcya/abcya_lib';
import UIAssetKeys from './UIAssetKeys';

/* eslint-disable object-shorthand */
export default function setupGameConfig(variantId, locale) {
  const config = {
    // add your game config options here, these can be the default values
    showOptions: true,
    levels: 6, // number of levels and a bonus (+1)
    subTitle: null,
    countBy: 1,
    spaceRocksPrefix: ''
  };
  switch (variantId) {
    // switch on your variant IDs here and set the needed config values
    case 'ones-a':
      config.showOptions = false;
      config.levels = 4;
      config.subTitle = UIAssetKeys._Subtitle_Ones;
      config.countBy = 1;
      break;
    case 'twos-a':
      config.showOptions = false;
      config.levels = 4;
      config.subTitle = UIAssetKeys._Subtitle_Twos;
      config.countBy = 2;
      break;
    case 'twos-b':
      config.showOptions = false;
      config.levels = 6;
      config.subTitle = UIAssetKeys._Subtitle_Twos;
      config.countBy = 2;
      break;
    case 'fives-a':
      config.showOptions = false;
      config.levels = 3;
      config.subTitle = UIAssetKeys._Subtitle_Fives;
      config.countBy = 5;
      break;
    case 'fives-b':
      config.showOptions = false;
      config.levels = 6;
      config.subTitle = UIAssetKeys._Subtitle_Fives;
      config.countBy = 5;
      break;
    case 'tens-a':
      config.showOptions = false;
      config.levels = 2;
      config.subTitle = UIAssetKeys._Subtitle_Tens;
      config.countBy = 10;
      break;
    case 'tens-b':
      config.showOptions = false;
      config.levels = 3;
      config.subTitle = UIAssetKeys._Subtitle_Tens;
      config.countBy = 10;
      break;
    case 'tens-c':
      config.showOptions = false;
      config.levels = 6;
      config.subTitle = UIAssetKeys._Subtitle_Tens;
      config.countBy = 10;
      break;
  }
  switch (locale) {
    case ABCyaLib.Environment.LOCALES.esUS:
      config.spaceRocksPrefix = '¡';
      break;
  }
  return config;
}